import React, { PropsWithChildren } from 'react';

import styles from './FormCardContent.module.scss';

export const FormCardContent = ({ children }: PropsWithChildren<{}>) => (
  <div className={styles.formCardContent}>{children}</div>
);
